import { useQuery } from '@tanstack/react-query';
import {
  ConfiguredOnlineServiceResponse, ConfiguredOnlineServiceStatusResponse,
  PaginationRequest,
  StartAppsResponse
} from '../govos.types';
import { GovosApiRoutes, govosClient } from '../govos-api';

export function useConfiguredOnlineDienstFetcher(
  pagination?: PaginationRequest<{ appIds: number[] }>
) {
  const { data: startApps } = useQuery<StartAppsResponse>({
    queryKey: [GovosApiRoutes.startApps()]
  });

  const onlinedienstStatusResponse = useQuery({
    queryKey: [
      GovosApiRoutes.configuredOnlinediensteStatus(
        pagination?.pageSize ?? 10,
        pagination?.pageIndex ?? 0,
        pagination?.search,
        (pagination?.params?.appIds.length ?? 0) === 0
          ? startApps?.userInfo.startApps.map((a) => a.appiid)
          : pagination?.params?.appIds
      )
    ],
    queryFn: () =>
      govosClient
        .get<ConfiguredOnlineServiceStatusResponse>(
          GovosApiRoutes.configuredOnlinediensteStatus(
            pagination?.pageSize ?? 10,
            pagination?.pageIndex ?? 0,
            pagination?.search,
            (pagination?.params?.appIds.length ?? 0) === 0
              ? startApps?.userInfo.startApps.map((a) => a.appiid)
              : pagination?.params?.appIds
          )
        )
        .then((res) => res.data),
    enabled: (startApps?.userInfo.startApps.length ?? 0) > 0
  });

  const onlinedienstResponse = useQuery({
    queryKey: [
      GovosApiRoutes.configuredOnlinedienste(
        pagination?.pageSize ?? 10,
        pagination?.pageIndex ?? 0,
        pagination?.search,
        (pagination?.params?.appIds.length ?? 0) === 0
          ? startApps?.userInfo.startApps.map((a) => a.appiid)
          : pagination?.params?.appIds
      )
    ],
    queryFn: () =>
      govosClient
        .get<ConfiguredOnlineServiceResponse>(
          GovosApiRoutes.configuredOnlinedienste(
            pagination?.pageSize ?? 10,
            pagination?.pageIndex ?? 0,
            pagination?.search,
            (pagination?.params?.appIds.length ?? 0) === 0
              ? startApps?.userInfo.startApps.map((a) => a.appiid)
              : pagination?.params?.appIds
          )
        )
        .then((res) => res.data),
    enabled: (startApps?.userInfo.startApps.length ?? 0) > 0,
    select: (data) => ({ ...data, startApps: startApps?.userInfo.startApps })
  });

  return { onlinedienstResponse, onlinedienstStatusResponse };
}
